import { Link } from "react-router-dom";

export const Monogram = ({ size = 64, className = "" }) => (
  <img src="/logo-mark.png" alt="FineSkin Beauty" width={size} height={size} data-testid="brand-monogram"
    className={`object-contain ${className}`} style={{ width: size, height: size }} />
);

export const Wordmark = ({ to = "/", height, className = "h-[62px] sm:h-[76px]" }) => (
  <Link to={to} data-testid="brand-wordmark" className="inline-flex items-center" aria-label="FineSkin Beauty">
    <img src="/logo-full.png" alt="FineSkin Beauty" style={height ? { height } : undefined} className={`w-auto object-contain ${height ? "" : className}`} />
  </Link>
);

export const Header = ({ right = null }) => (
  <header className="flex items-center justify-between px-6 sm:px-10 py-3">
    <Wordmark />
    <div className="flex items-center gap-4">
      {right}
      <Link to="/admin/login" data-testid="admin-access-link" className="text-[11px] tracking-[0.2em] uppercase text-[#8C8275] hover:text-[#1A1A18] transition-colors">Admin</Link>
    </div>
  </header>
);
